import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { EmptyState } from "@/components";
import { Paper } from "@mui/material";

interface Props {
    onCreate: () => void;
}

const Empty = ({ onCreate }: Props) => {
    return (
        <Paper
            elevation={2}
            sx={{
            padding: 2,
            borderRadius: 2,
            }}
        >
            <EmptyState
                action={{
                    onClick: onCreate,
                    startIcon: <HugeiconsIcon icon={Add01Icon} />,
                    children: 'Agregar Configuración',
                    variant: 'outlined',
                }}
            />
        </Paper>
    )
}

export default Empty;
